export interface TeamPhoto {
  src: string;
  /** CSS object-position keeping everyone's faces in frame */
  position?: string;
  /** members left-to-right as they appear in the photo */
  order?: string[];
}

// Group photos per team, keyed by team number. Teams without one show a placeholder.
export const teamPhotos: Record<number, TeamPhoto> = {
  1: {
    src: "https://cdn.magicpatterns.com/uploads/iA7iQ7oBUTBvxZDwvTGACV/image.png",
    // Cropped below the whiteboard so the Wi-Fi password isn't shown.
    position: "50% 64%",
    order: ["Joao Mourao", "Felipe Argolo", "Dhevarshini"],
  },
  2: {
    src: "https://cdn.magicpatterns.com/uploads/sevMuqTJ3UhP8XAHdx8HAV/image.png",
    position: "50% 38%",
    order: ["Saanvi", "Lorenzo Vitti"],
  },
  3: {
    src: "https://cdn.magicpatterns.com/uploads/jQuSBWhasBVP4DYLWEBL2P/image.png",
    position: "50% 52%",
    order: ["Diogo Chiapeta", "Aadhya"],
  },
  4: {
    src: "https://cdn.magicpatterns.com/uploads/i8RU74rDZi8mU8hAacbeve/image.png",
    position: "50% 54%",
    order: ["Niyathi", "Carol GCO"],
  },
  5: {
    src: "https://cdn.magicpatterns.com/uploads/e782WQGzvT5cpLDhzUamqD/image.png",
    position: "50% 50%",
    order: ["Aishwarya", "Hugo Mendes"],
  },
};
